function getOpt (dataObj) {
 let xData = dataObj.typeId;
 let y1Data = dataObj.myValue;
 let y2Data = dataObj.otherValue;

 return {
  backgroundColor: "transparent",
  tooltip: {
   show: true,
   trigger: 'axis',
   backgroundColor: 'rgba(4, 21, 39, 1)',
   borderWidth: 0,
   textStyle: {
    color: '#fff'
   }
  },
  legend: {
   show: true,
   icon: 'roundRect',
   itemWidth: 26,
   itemHeight: 16,
   right: '2%',
   top: '10%',
   itemGap: 15.5,
   textStyle: {
    fontSize: 14,
    color: 'rgba(255,255,255,1)',
    padding: [2, 0, 0, 0]
   }
  },
  grid: {
   top: '22%',
   left: '5%',
   right: '3%',
   bottom: '5%',
   containLabel: true,
  },
  xAxis: [{
   type: 'category',
   axisLine: {
    show: true,
    lineStyle: {
     color: '#093E95',
     width: 1
    },
   },
   splitLine: {
    show: true,
    lineStyle: {
     color: '#3E86DB',
     width: 0.3
    }
   },
   boundaryGap: true,
   axisLabel: {
    textStyle: {
      color: '#F9F9F9',
      fontSize: 12,
      // margin: 15,
    },
   },
   axisTick: {
    show: false,
   },
   data: xData,
  }],
  yAxis: [{
   name: '吨（T）',
   nameTextStyle: {
    fontSize: 14,
    color: "#F9F9F9",
    padding: [0, 0, 0, 10]
   },
   type: 'value',
   min: 0,
   // minInterval: 50,
   splitLine: {
    show: true,
    lineStyle: {
     color: '#3E86DB',
     width: 0.3
    }
   },
   axisLine: {
    show: true,
    lineStyle: {
     color: '#3E86DB',
     width: 1
    }
   },
   axisLabel: {
    margin: 10,
    textStyle: {
     color: '#F9F9F9',
     fontSize: 14,
    },
   },
   axisTick: {
    show: false,
   },
  }],
  series: [{
   name: "矿",
   type: 'bar',
   barMaxWidth: "20%",
   itemStyle: {
    barBorderRadius: [3, 3, 0, 0],
    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
     offset: 0,
     color: '#6DA6D7'
    },
    {
     offset: 1,
     color: '#3023AE'
    }
    ], false)
   },
   data: y1Data
  }, {
   name: "焦炭",
   type: 'bar',
   barMaxWidth: "20%",
   itemStyle: {
    barBorderRadius: [3, 3, 0, 0],
    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
     offset: 0,
     color: '#FFEDB6'
    },
    {
     offset: 1,
     color: '#EA7777'
    }
    ], false)
   },
   data: y2Data
  }]
 };
}

export default getOpt